import { GET_USER } from '../actionTypes';

const userReducer = function (state = {}, action) {
    switch (action.type) {
        case GET_USER:
            return action.payload;
        default:
            return state;
    }
}

export default userReducer